import { render, staticRenderFns } from "./PaywallDialog.vue?vue&type=template&id=1c23c170"
import script from "./PaywallDialog.vue?vue&type=script&lang=js"
export * from "./PaywallDialog.vue?vue&type=script&lang=js"
import style0 from "./PaywallDialog.vue?vue&type=style&index=0&id=1c23c170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports